<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Carousel, Slide } from "vue-carousel";
import Sorter from "@/helpers/sorter";
import EditClientActionModal from "./modals/editClientActionModal";
import NewDeliveryDateModal from "./modals/deliveryDateRequestModal";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import Repositories from "@/repositories";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Carousel,
    Slide,
    Loading,
    EditClientActionModal,
    Multiselect,
    NewDeliveryDateModal
  },
  data() {
    return {
      isLoading: false,
      dropDownTrackingNumber: null,
      allowDeliveryDateModification: false,
      deliveryDateModificationMessage: "",
      mailtoemails: "",
      showDeliveryDate: false,
      showInstallationDate: false,
      workorder: {
        clientActions: []
      },
      workOrderRepository: null,
      organisationConfigurationRepository: null,
      clientActionRepository: null
    };
  },
  mounted() { },
  methods: {
    nextSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    prevSlide() {
      this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    openWarning(step) {
      Swal.fire("", step.warning, "warning");
    },
    openEditClientAction(action) {
      this.$refs.editClientActionModal.openEditClientActionModal(action).then((action) => {
        var clientAction = this.workorder.clientActions.filter(x => x.idPublic == action.idPublic)[0];
        clientAction.description = action.description;
      });
    },
    actionDone(action) {
      this.isLoading = true;
      this.clientActionRepository.actions.updateIsDone(action).then(() => {
      }, (error) => {
        window.console.error(error);
        action.isDone = !action.isDone;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    deleteClientAction(action) {
      Swal.fire({
        title: this.$t("general.delete"),
        text: this.$t("clientaction.confirmdelete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#f46a6a",
        cancelButtonColor: "#34c38f",
        confirmButtonText: this.$t("general.delete")
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          this.clientActionRepository.delete(action, action.idPublic).then(() => {
            this.workorder.clientActions = this.workorder.clientActions.slice().filter(x => x.idPublic != action.idPublic);
            Swal.fire(this.$t("general.deleted") + "!", this.$t("clientactions.confirmdeleted"), "success");
          }, (error) => {
            window.console.error(error);
          }).finally(() => {
            this.isLoading = false;
          });
        }
      });
    },
    changeworkorder(workorder) {
      if (workorder.trackingNumber != this.dropDownTrackingNumber.trackingNumber) {
        this.$router.push({
          name: "workorder",
          params: { trackingnumber: workorder.trackingNumber, organisationcode: this.$route.params.organisationcode }
        });
        this.loadData(workorder.trackingNumber);
      }
    },
    loadData(trackingnumber) {
      this.isLoading = true;
      this.organisationConfigurationRepository.actions.getPublic().then((response) => {
        this.allowDeliveryDateModification = response.data.allowDeliveryDateModification;
        this.deliveryDateModificationMessage = response.data.deliveryDateModificationMessage;
        this.showDeliveryDate = response.data.showDeliveryDate;
        this.showInstallationDate = response.data.showInstallationDate;
        this.mailtoemails = response.data.mailToEmails;
        this.workOrderRepository.get(trackingnumber).then((response) => {
          this.workorder = response.data;
          this.workorder.steps.sort(Sorter.compareDisplayOrder);
          this.workorder.clientActions.sort(Sorter.compareDisplayOrder);
          this.workorder.requestedDeliveryDate = this.workorder.requestedDeliveryDate ?
            this.$dayjs(this.workorder.requestedDeliveryDate).format("YYYY-MM-DD") :
            null;
          this.workorder.estimatedDeliveryDate = this.workorder.estimatedDeliveryDate ?
            this.$dayjs(this.workorder.estimatedDeliveryDate).format("YYYY-MM-DD") :
            null;
          this.workorder.installationDate = this.workorder.installationDate ?
            this.$dayjs(this.workorder.installationDate).format("YYYY-MM-DD") :
            null;
            this.workorder.associatedWorkOrders.sort(Sorter.compareIsCompleted)
          this.dropDownTrackingNumber = this.workorder.associatedWorkOrders.filter(x => x.trackingNumber == trackingnumber)[0];
        }, (error) => {
          Swal.fire("", error.message, "warning").then(() => {
            this.$router.push({
              name: "search",
              params: { organisationcode: this.$route.params.organisationcode }
            });
          });
          window.console.error(error);
        });
      }, (error) => {
        window.console.error(error);
        Swal.fire("", error.message, "warning").then(() => {
          this.$router.push({
            name: "search",
            params: { organisationcode: this.$route.params.organisationcode }
          });
        });
      }).finally(() => {
        this.isLoading = false;
      });
    },
    openNewDeliveryDateModal() {
      this.$refs.newDeliveryDateModal.openDeliveryDateRequestModal(this.$route.params.trackingnumber, this.workorder.estimatedDeliveryDate).then((newRequestedDeliveryDate) => {
        this.workorder.requestedDeliveryDate = newRequestedDeliveryDate;
      })
    },
    getEventIconClass(index) {
      if (index == 0) {
        return 'event-down-icon event-down-icon-first';
      }
      if (index == this.nbWorkOrderSteps - 1) {
        return 'event-down-icon event-down-icon-last';
      }
      return 'event-down-icon';
    },
    project_formater({ isCompleted, displayName }) {
      if (isCompleted) {
        return <b>{{ displayName }}</b>
      }
      return <p>{{ displayName }}</p>
    }
  },
  computed: {
    nbWorkOrderSteps() {
      return this.workorder.steps?.length ?? 0;
    },
    slideNumber() {
      return Math.max(Math.min(this.nbWorkOrderSteps, 9), 4);
    },
    showNextSlide() {
      return this.slideNumber < this.nbWorkOrderSteps;
    },
    historySteps() {
      var history = [];
      var steplist = this.workorder.steps?.filter(x => x.dateStarted || x.dateDone) ?? [];
      for (var i = 0; i < steplist.length; i++) {
        history.push({
          date: this.$dayjs(steplist[i].dateStarted + 'Z').format("YYYY-MM-DD HH:mm"),
          statusName: "Started",
          stepName: steplist[i].stepName,
          description: "",
          icone: steplist[i].isDone ? "bx bxs-badge-check h1 text-success down-arrow-icon" : "bx bx-hourglass h1 text-secondary down-arrow-icon"
        });
        if (steplist[i].dateDone) {
          history.push({
            date: this.$dayjs(steplist[i].dateDone + 'Z').format("YYYY-MM-DD HH:mm"),
            statusName: "Completed",
            stepName: steplist[i].stepName,
            description: "",
            icone: steplist[i].dateDone ? "bx bxs-badge-check h1 text-success down-arrow-icon" : "bx bx-hourglass h1 text-secondary down-arrow-icon"
          });
        }
      }
      return history.sort(Sorter.compareDate);
    },
    currentAccount() {
      return this.$msal.currentAccount;
    }
  },
  created() {
    this.workOrderRepository = Repositories.get("workorders", this.$route.params.organisationcode);
    this.organisationConfigurationRepository = Repositories.get("organisationconfiguration", this.$route.params.organisationcode);
    this.clientActionRepository = Repositories.get("clientactions", this.$route.params.organisationcode);
    this.loadData(this.$route.params.trackingnumber);
  }
};
</script>

<template>
  <Layout>
    <loading :active.sync="isLoading" :can-cancel="false" color='#f1b44c' :width=70 :height=70 loader='dots'
      :is-full-page="true">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <b-alert show variant="warning" v-if="workorder.requestedDeliveryDate !== null" style="text-align:center;">{{
          $t("workorder.deliverydaterequested").replace("{0}",
            workorder.requestedDeliveryDate) }}</b-alert>
        <div class="card">
          <div class="card-body">
            <b-form class="project-header" inline>
              <div class="col-md-4 project">
                <h5 style="display:inline-block;margin-right: 1em;align-self:center;">{{ $t("workorder.title") }}</h5>
                <multiselect v-model="dropDownTrackingNumber" @select="changeworkorder"
                  :options="workorder.associatedWorkOrders" v-if="workorder.associatedWorkOrders" label="displayName"
                  :show-labels="false" :allow-empty="false" class="project-selector" placeholder="">
                  <template slot="option" slot-scope="props">
                    <span :class="{'font-weight-light; font-italic': props.option.isCompleted}">{{ props.option.displayName }}</span>
                  </template>
                </multiselect>
              </div>
              <div class="col">
                <div class="d-flex flex-column align-items-center">
                  <div class="font-weight-bold">{{ workorder.clientName }}</div>
                  <div>{{ workorder.clientAddress }}</div>
                  <div>{{ workorder.clientAddressLine2 }}</div>
                  <div>
                    <span v-if="workorder.clientCity">{{ workorder.clientCity }}, </span>
                    <span v-if="workorder.clientState">{{ workorder.clientState }}, </span>
                    {{ workorder.clientZipCode }}
                  </div>
                </div>
                <div class="mail-to-email mt-2" v-if="mailtoemails">
                  <span class="font-weight-bold">{{ $t("general.contactemail") }}</span>
                  <a :href="'mailto:' + mailtoemails">{{ mailtoemails }}</a>
                </div>
              </div>
              <div class="d-flex">
                <div style="display:flex;flex-direction:column;justify-content:flex-end;">
                  <div style="display:flex;justify-content:flex-end;" v-if="showDeliveryDate">
                    <h5 style="display:inline-block;margin-right: 1em;align-self:center;">
                      {{ $t("workorder.estimateddelivery") }}</h5>
                    <b-form-input id="date" v-model="workorder.estimatedDeliveryDate" type="date"
                      :disabled="true"></b-form-input>
                  </div>
                  <div style="display:flex;justify-content:flex-end;margin-top:5px;" v-if="showInstallationDate">
                    <h5 style="display:inline-block;margin-right: 1em;align-self:center;">
                      {{ $t("workorder.installationdate") }}</h5>
                    <b-form-input id="date" v-model="workorder.installationDate" type="date"
                      :disabled="true"></b-form-input>
                  </div>
                </div>
                <b-button v-if="!workorder.requestedDeliveryDate && allowDeliveryDateModification" variant="warning"
                  class="change-delivery-date-btn" @click="openNewDeliveryDateModal" style="height:36px">{{
                    $t("general.modify") }}</b-button>
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="hori-timeline">
              <carousel ref="carousel" class="events navs-carousel" id="timeline-carousel" :navigation-enabled="false"
                :pagination-enabled="false" :perPage="slideNumber">
                <slide v-for="(step, stepIndex) in workorder.steps" :key="step.idPublic">
                  <div class="item event-list">
                    <div>
                      <div class="event-date">
                        <h5 class="mb-4">{{ step.stepName }}</h5>
                      </div>
                      <div :class="getEventIconClass(stepIndex)">
                        <i v-if="step.dateDone" class="bx bxs-badge-check h1 text-success down-arrow-icon"></i>
                        <i v-else-if="step.dateStarted" class="bx bx-hourglass h1 text-secondary down-arrow-icon"></i>
                        <i v-else class="bx bx-radio-circle h1 text-secondary down-arrow-icon"></i>
                        <i v-if="step.warning" @click="openWarning(step)"
                          class="bx bx-error h1 text-danger cursor-pointer"></i>
                      </div>
                      <div v-if="step.dateDone" class="text-primary mb-1">{{ $dayjs(step.dateDone).format("YYYY-MM-DD") }}
                      </div>
                      <div v-else-if="step.dateStarted" class="text-primary mb-1">
                        {{ $dayjs(step.dateStarted).format("YYYY-MM-DD") }}</div>
                    </div>
                  </div>
                </slide>
              </carousel>
              <div class="owl-nav" v-if="showNextSlide">
                <button type="button" role="presentation" class="owl-prev" @click.prevent="prevSlide">
                  <i class="mdi mdi-chevron-left"></i>
                </button>
                <button type="button" role="presentation" class="owl-next" @click.prevent="nextSlide">
                  <i class="mdi mdi-chevron-right"></i>
                </button>
              </div>
            </div>
            <ul class="verti-timeline list-unstyled" v-for="(step) in workorder.steps" :key="step.idPublic">
              <li class="event-list" style="padding-top:20px;padding-bottom:20px;">
                <div class="event-timeline-dot">
                  <i v-if="step.dateDone" class="bx bxs-badge-check h1 text-success down-arrow-icon"></i>
                  <i v-else-if="step.dateStarted" class="bx bx-hourglass h1 text-secondary down-arrow-icon"></i>
                  <i v-else class="bx bx-radio-circle h1 text-secondary down-arrow-icon"></i>
                  <i v-if="step.warning" @click="openWarning(step)" class="bx bx-error h1 text-danger cursor-pointer"></i>
                </div>
                <div class="media">
                  <div class="media-body">
                    <div style="margin-left:10px;">
                      <h5>{{ step.stepName }}</h5>
                      <p v-if="step.dateDone" class="text-muted">{{ $dayjs(step.dateDone).format("YYYY-MM-DD") }}</p>
                      <p v-else-if="step.dateStarted" class="text-muted">{{ $dayjs(step.dateStarted).format("YYYY-MM-DD")
                      }}
                      </p>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-todo">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">{{ $t("general.todo") }}</h4>
            <div class="table-responsive mb-0">
              <table class="table table-centered">
                <tbody
                  v-if="currentAccount != null && currentAccount.idTokenClaims.extension_TrackingManagementHasAccess">
                  <tr v-for="action in workorder.clientActions" :key="action.idPublic">
                    <td>
                      <input :id="'isdone-' + action.idPublic" type="checkbox" class="" v-model="action.isDone"
                        @change="actionDone(action)" />
                    </td>
                    <td>
                      <h5 class="font-size-14 m-0">
                        <a href="javascript: void(0);" class="text-dark">{{ action.description }}</a>
                      </h5>
                    </td>
                    <td>
                      <div class="text-center text-truncate">
                        <a :id="'edit-action-' + action.idPublic" @click="openEditClientAction(action)"
                          class="cursor-pointer"><i class="bx bx-edit h1 text-success down-arrow-icon"></i></a>
                        <b-tooltip :target="'edit-action-' + action.idPublic" placement="bottom">{{ $t("general.edit")
                        }}</b-tooltip>
                        <a :id="'delete-action-' + action.idPublic" @click="deleteClientAction(action)"
                          class="cursor-pointer"><i class="bx bx-trash h1 text-danger down-arrow-icon"></i></a>
                        <b-tooltip :target="'delete-action-' + action.idPublic" placement="bottom">{{ $t("general.delete")
                        }}</b-tooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr v-for="action in workorder.clientActions" :key="action.idPublic">
                    <td style="width: 60px;">
                      <input :id="'isdone-' + action.idPublic" type="checkbox" class="" v-model="action.isDone"
                        @change="actionDone(action)" />
                    </td>
                    <td>
                      <h5 class="text-truncate font-size-14 m-0">
                        <a href="javascript: void(0);" class="text-dark">{{ action.description }}</a>
                      </h5>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">{{ $t("general.history") }}</h4>
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Date</th>
                    <th>{{ $t("general.step") }}</th>
                    <th>Status</th>
                    <th> </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="historySteps.length == 0">
                    <td colspan="4">{{ $t("general.noresult") }}</td>
                  </tr>
                  <tr v-for="(step, index) in historySteps" :key="step.idPublic">
                    <th scope="row">{{ index }}</th>
                    <td>{{ step.date }}</td>
                    <td>{{ step.stepName }}</td>
                    <td>{{ $t("status." + step.statusName) }}</td>
                    <td><i :class="step.icone"></i></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <EditClientActionModal ref="editClientActionModal" />
    <NewDeliveryDateModal ref="newDeliveryDateModal" :message="deliveryDateModificationMessage" />
  </Layout>
</template>
<style scoped>
@media(max-width: 600px) {
  .hori-timeline {
    display: none;
  }
}

@media(min-width: 600px) {
  .verti-timeline {
    display: none;
  }
}

@media(max-width: 1200px) {

  .col-lg-4,
  .col-lg-8 {
    position: relative;
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
    flex: 0 0 100%;
    max-width: 100%;
  }

  .mail-to-email {
    order: -1;
    justify-content: center;
    max-width: 100%;
    flex: 0 0 100%;
    margin-bottom: 20px;
  }

  .project-header {
    flex-direction: column;
  }

  .project {
    flex: 0 0 100%;
    margin-bottom: 20px;
  }
}

.project-header {
  display: flex;
  justify-content: space-between;
}

.project {
  display: flex;
  align-content: flex-end;
}

.project-selector {
  min-width: 200px;

}

.mail-to-email {
  display: flex;
  flex-direction: column;
  text-align: center;
}

.verti-timeline .event-list .event-timeline-dot {
  left: -18px;
  top: 25px;
}

.bx-error {
  position: relative;
}

.cursor-pointer:hover {
  cursor: pointer;
}

.trackingnumber-input {
  display: inline-block;
  width: 310px;
}

.change-delivery-date-btn {
  margin-left: 1em;
}

.event-down-icon-first {
  text-align: left;
  margin-left: 46%;
}

.event-down-icon-last {
  text-align: right;
  margin-right: 46%;
}
</style>